import { AppAreaConfig } from '@/funnels/@types'
import pilatesFemale from './activity-female-pilates'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-boudoir-pilates-fwf',
	landing: {
		ids: ['loader-boudoir-pilates-f', 'age-boudoir-pilates-f'],
		route: {
			path: '/boudoir-pilates-f',
			name: 'female-boudoir-pilates-funnel',
		},
	},
	funnel: {
		id: 'ob-boudoir-pilates-female-fwf',
		route: {
			path: '/boudoir-pilates-f/ob/:page*',
			name: 'activity-female-boudoir-pilates-fwf',
		},
		slug: 'activity-female-boudoir-pilates-fwf',
		theme: 'light',
		locale: ['en'],
		redirectTo: {
			always: {
				appArea: pilatesFemale,
				page: 'physical-build',
			},
		},
	},
}

export default appAreaConfig
